module.exports = __webpack_public_path__ + "static/media/purser.c7857636.png";